import { AdvancedFeaturesIcon } from '@/svgs'
import React from 'react'

function AdvancedFeatures() {
   return (
      <section className="fantasy-features section_secondary_bg">
         <div className="container p-lg-0 p-2">
            <div className="fantasy-features-section px-3 px-sm-4 px-lg-0 text-center">
               <h2 className="fantasy-features-title tech_title">
                  Advanced Features That Power Your Fantasy Game App
               </h2>
               <p className="fantasy-features-subtitle">
                  We go beyond the basics with a robust set of additional
                  features designed to enhance user engagement, streamline admin
                  operations, and deliver a seamless gaming experience.
               </p>
               <AdvancedFeaturesIcon />
            </div>
         </div>
      </section>
   )
}

export default AdvancedFeatures
